import {
	setCurrentMerchant,
	setCurrentBranch,
	setSubscriptions,
	setAssignedLicenses,
	setReportFilter,
	setBranchIds,
} from '@/helpers/WorkspaceHelper';
import {
	CHANGE_BRANCH,
	CHANGE_BRANCH_IDS,
	CHANGE_MERCHANT,
	CHANGE_SUBSCRIPTIONS,
	CHANGE_ASSIGNED_LICENSES,
	CLEAR_WORKSPACE,
	CHANGE_REPORT_FILTERS,
} from '../actions-registry';

export const changeMerchant = (payload) => {
	setCurrentMerchant(payload);
	return {
		type: CHANGE_MERCHANT,
		payload,
	};
};
export const changeBranch = (payload) => {
	setCurrentBranch(payload);
	return {
		type: CHANGE_BRANCH,
		payload,
	};
};
export const changeBranchIds = (payload) => {
	setBranchIds(payload);
	return {
		type: CHANGE_BRANCH_IDS,
		payload,
	};
};
export const changeSubscriptions = (payload) => {
	setSubscriptions(payload);
	return {
		type: CHANGE_SUBSCRIPTIONS,
		payload,
	};
};
export const changeAssignedLicenses = (payload) => {
	setAssignedLicenses(payload);
	return {
		type: CHANGE_ASSIGNED_LICENSES,
		payload,
	};
};
export const changeReportFilter = (payload) => {
	setReportFilter(payload);
	return {
		type: CHANGE_REPORT_FILTERS,
		payload,
	};
};
export const clearWorkspace = () => {
	setCurrentMerchant(null);
	setCurrentBranch(null);
	setBranchIds(null);
	setSubscriptions(null);
	setAssignedLicenses(null);
	setReportFilter(null);
	return {
		type: CLEAR_WORKSPACE,
	};
};
